import { State } from '../../type'
import { moduleName } from './constants'
import { IChatSocketState } from './types'

const getState = (state: State): IChatSocketState => state[moduleName]

export const getUnreadSocketMessages = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.unread_messages
}

export const getLastSocketMessage = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.unread_messages[stateSlice.unread_messages.length - 1]
}

export const getTotalUnreadMessages = (state: State) => {
  const stateSlice = getState(state)
  return stateSlice.total_unread_messages
}
